import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentReviewTask } from '../../adapters/reviewTask';
import alert from '../../assets/sounds/alert.ogg';
import { Loading } from '../../elements/Loading';
import styles from './ReviewPending.module.scss';

export function ReviewPending() {
  const [isInitializing, setIsInitializing] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(async () => {
      const task = await getCurrentReviewTask();
      if (task) {
        const audio = new Audio(alert);
        audio.play();
        navigate('/review_tasks');
      }
    }, 5 * 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  useEffect(() => {
    setIsInitializing(true);
    document.title = 'Saleswhale Overmind';
    (async () => {
      try {
        const task = await getCurrentReviewTask();
        if (task) {
          navigate('/review_tasks');
        }
      } catch (e) {
        throw e;
      } finally {
        setIsInitializing(false);
      }
    })();
  }, [navigate]);

  if (isInitializing) return <Loading />;
  return (
    <div className={styles.Container} data-testid="ReviewTaskPending">
      <div>
        <h1>No email review tasks!</h1>
        <p>Helping you fetch new tasks if available...</p>
      </div>
    </div>
  );
}
